import { render } from "./TheA01MessagePanel.vue?vue&type=template&id=422d61b1&scoped=true&ts=true"
import script from "./TheA01MessagePanel.vue?vue&type=script&lang=ts"
export * from "./TheA01MessagePanel.vue?vue&type=script&lang=ts"

import "./TheA01MessagePanel.vue?vue&type=style&index=0&id=422d61b1&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-422d61b1"]])

export default __exports__